import { create } from 'zustand';
import { ApiUtils, ApplicationApi, ManualApplicationDownloadParams, RequestStrategyEnum } from '@shared/api';

interface IRejectManualApplicationStore {
  loading: boolean;
  error: string | null;
  success: boolean;
  rejectManualApplication: (searchParams: ManualApplicationDownloadParams, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useRejectManualApplicationStore = create<IRejectManualApplicationStore>((set) => ({
  loading: false,
  error: null,
  success: false,

  rejectManualApplication: ApiUtils.wrapperApi(async (searchParams: ManualApplicationDownloadParams, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      await ApplicationApi.rejectManualApplication(searchParams, signal);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ success: false, loading: false, error: null }),
}));
